'use client';

import { addPlayerGroups, type User } from '@/api/auth';
import type { CmsABTest } from '@/api/cms/abTests';
import { sendOtherABTestAssignmentEvent } from '@/modules/googleAnalytics/events/otherEvents';
import { useLocalStorageStore } from '@/store';
import type { CommonStoreType } from '@/store/commonStore/types';
import type { ABTestVersion } from '../types';
import { checkAbTestVersion } from './checkAbTestVersion';
import { getRandomABTestVersion } from './getRandomABTestVersion';

export interface AssignABTestVersionParams {
  experiment: string;
  cmsABTests: CmsABTest[];
  versions: ABTestVersion[];
  user?: User;
  refreshUser: CommonStoreType['refreshUser'];
}

export const assignABTestVersion = (params: AssignABTestVersionParams) => {
  const existingVersion = checkAbTestVersion(params);

  if (existingVersion) return existingVersion;

  const newVersion = getRandomABTestVersion(params.versions);
  if (!newVersion) return;

  useLocalStorageStore
    .getState()
    .replace(params.experiment, { name: newVersion.name });

  if (params.user) {
    addPlayerGroups([newVersion.name])
      .then((res) => {
        if (!res.error) params.refreshUser();
      })
      .catch((err) => console.error('addPlayerGroups failed:', err));
  }

  sendOtherABTestAssignmentEvent({
    test_name: params.experiment,
    test_group: newVersion.name,
    test_version: newVersion.name.split(':').at(-1) as string,
  });

  return newVersion.name;
};
